// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__2WgRM","form":"form__7_NP2","content":"content__-YnkT","input":"input__3Vqgf","email":"email__2EYRM","buttonEmailWrap":"buttonEmailWrap__3wRlh","button":"button__3ZGOR","icon":"icon__1ePEc","recaptchaWrap":"recaptchaWrap__2hu--","copyText":"copyText__1OH5z","recaptcha":"recaptcha__3Hc0k","recaptcha_0":"recaptcha_0__1gToJ","formThankYou":"formThankYou__2wijY"};


//////////////////
// WEBPACK FOOTER
// ./components/footer-form/style.styl
// module id = 1Y5v
// module chunks = 0